export default class ChatChannelCreation {
  public userExternalId: string;
  public message: string;

  constructor(userExternalId: string, message: string) {
    this.userExternalId = userExternalId;
    this.message = message;
  }
}
